export enum MessageStatus {
  SUCCESS = 'Success',
  FAILED = 'Failed',
  PROCESSING = 'Processing'
}